<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button class="btn btn-outline-success" type="button" (click)="onAdd()" *ngIf="editTitle.includes('Editar')"><i class="fa fa-file-o"></i> Nueva Forma </button>
            <button *ngIf="!visibilitySpinner" type="submit" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}}</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-8">
                                <label class="col-form-label required-field" for="inpDescripcion">Nombre Grupo</label>
                                <input formControlName="Descripcion" maxlength="300" inputStyleClass="form-control"
                                       [ngClass]="displayFieldCss('Descripcion')"
                                       class="form-control" id="inpDescripcion" type="text" value="">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','required')">
                                    Nombre Grupo es obligatorio
                                </div>
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','descripcion_duplicated')">
                                    El Nombre de Grupo ya existe
                                </div>
                            </div>

                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="EmbalajeObligatorio">Embalaje obligatorio</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="EmbalajeObligatorio"
                                                onLabel="Sí" offLabel="NO"
                                                onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <!--DATAGRID-->

        <div *ngIf="editTitle.includes('Editar')" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Formas
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultForma.ResultList" [lazy]="true"
                                 [totalRecords]="resultForma.TotalCount" [loading]="loading"
                                 styleClass="table table-responsive-sm  table-striped table-sm"
                                 [ngClass]="displayGridHidden(resultForma.ResultList)">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <!--<td></td>
                                        <td>Nombre Forma</td>
                                        <td>Nombre Forma (Inglés)</td>
                                        <td>Código TRACES (Tipo de Producto)</td>-->
                                    <th scope="col"></th>
                                    <th scope="col">Forma</th>
                                    <th scope="col">Nombre Forma (Inglés)</th>
                                    <th scope="col">Código TRACES (Tipo de Producto)</th>
                                    <th scope="col">Ephyto R.U.</th>
                                    <th scope="col">Especies sin EPPO</th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-item>
                                <tr>
                                    <td>
                                        <div class="btn-group">
                                            <button (click)="onEdit(item)" type="button" title="Editar"
                                                    class="btn btn-sm btn-warning">
                                                <span class="fa fa-edit"></span>

                                            </button>
                                            <button (click)="onDelete(item)" type="button" title="Eliminar"
                                                    class="btn btn-sm btn-danger">
                                                <span class="fa fa-remove"></span>

                                            </button>
                                        </div>
                                    </td>
                                    <td>{{item.Descripcion}}</td>
                                    <td>{{item.DescripcionIngles}}</td>
                                    <td>{{item.TracesProductCode}}</td>
                                    <td>{{item.EphytoReinoUnido | siNo}}</td>
                                    <td>{{item.EspecieSinEppo | siNo}}</td>
                                </tr>

                            </ng-template>
                        </p-table>
                        <div *ngIf="totalregistros === 0" class="empty-grid">
                            No hay formas asociadas a este grupo
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</form>
